//action that changes the store settings
import {
    ARTICLE_FORM_ATTACHMENT_REMOVE, ARTICLE_FORM_ATTACHMENTS_CHANGE, CHANGE_ARTICLE_FORM_INFO_STATE,
    CHANGE_ARTICLE_FORM_SETTINGS,
    FAILED_TO_POST_NEW_ARTICLE,
    RECEIVE_POST_NEW_ARTICLE,
    REQUEST_POST_NEW_ARTICLE
} from "./index";

export function changeArticleFormSettings(key, value){
    return {
        type: CHANGE_ARTICLE_FORM_SETTINGS,
        payload: {
            key,
            value
        }
    }
}


//action that changes the required field data stored in redux
export function articleFormAttachmentsChange(attachment) {
    return {
        type: ARTICLE_FORM_ATTACHMENTS_CHANGE,
        payload: attachment
    }
}

//action that changes the required field data stored in redux
export function articleFormAttachmentRemove(attachmentIndex) {
    return {
        type: ARTICLE_FORM_ATTACHMENT_REMOVE,
        payload: attachmentIndex
    }
}


//action that requests post new article
export function requestPostNewArticle(sendBody) {
    return {
        type: REQUEST_POST_NEW_ARTICLE,
        payload: sendBody
    }
}

//action that receives get post new article
export function receivePostNewArticle(response) {
    return {
        type: RECEIVE_POST_NEW_ARTICLE,
        payload: response
    }
}

//action that receives failed get post new article
export function failedToPostNewArticle(response) {
    return {
        type: FAILED_TO_POST_NEW_ARTICLE,
        payload: response
    }
}

//action that enables and disables the desired form field info tooltip
export function changeArticleFormInfoState(key){
    return{
        type: CHANGE_ARTICLE_FORM_INFO_STATE,
        payload: {
            key
        }
    }
}

